import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { addCohortListItem } from 'Workspace/Cohorts/store/actions';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import { hideModal } from 'containers/ModalManager/actions';
import { CREATE_COHORT_MODAL } from 'containers/ModalManager/constants';
import catchErrors from 'utils/commands/catchErrors';
import { isValidProductModel } from 'Workspace/Cohorts/components/CohortsPage/productModelConstants';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  let cohortCreateObj = {
    type: constants.RTM_WORKSPACE_COHORT_CREATE,
    name: action.cohort.name,
    startDate: action.cohort.startDate,
    endDate: action.cohort.endDate,
    enrollmentType: action.cohort.enrollmentType,
    productId: action.cohort.productId,
    workspaceId: action.cohort.workspaceId,
  };
  const { ltiConsumerCredential, productModel } = action.cohort;
  if (isValidProductModel(productModel)) {
    cohortCreateObj.productModel = productModel;
  }
  cohortCreateObj = { ...cohortCreateObj, ...(ltiConsumerCredential ? { ltiConsumerCredential } : {}) };
  const workspaceCohortCreate = yield call(connection.fetch.bind(connection), cohortCreateObj);

  if (workspaceCohortCreate.type === constants.RTM_WORKSPACE_COHORT_CREATE_OK) {
    const cohort = workspaceCohortCreate.response.cohort;
    yield put(addCohortListItem(cohort.summary));
  } else {
    yield put(
      pushToast({
        type: 'simple',
        message: <FormattedMessage {...messages.failedWorkspaceCohortCreate} />,
      })
    );
  }
  yield put(hideModal(CREATE_COHORT_MODAL));
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT_CREATE, catchErrors, sendRequest, connection);
}
